import { Injectable } from '@angular/core';
import { HttpBackend, HttpRequest, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  private configData: any;

  constructor (
    protected http: HttpBackend
  ) { }

  public get hasConfigLoaded(): boolean {
    return !!this.configData;
  }

  public getValue(key: string): string {
    if (!this.hasConfigLoaded) {
      throw new Error('Configuration not loaded');
    }

    return this.configData[key];
  }

  public loadConfiguration(): Promise<any> {
    return this.http.handle(new HttpRequest('GET', `config.json`))
            .toPromise()
            .then((configData: HttpResponse<any>) => {
              this.configData = configData.body;
            })
            .catch(() => {});
  }
}

export function appConfigurationServiceFactory(appConfigurationService: AppConfigurationService): Function {
  return () => appConfigurationService.loadConfiguration();
}
